module.exports = __webpack_public_path__ + "img/linkedLists.ee4431d6.svg";